import axios from 'axios';
import {ENV} from '../../util/Env';

const getAuthToken = () => sessionStorage.getItem('yourAuthTokenKey');

const axiosInstance = axios.create({
    baseURL: ENV.API_URL,
    // timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
    },
});

const handleRequestError = (error) => {
    if (error.response) {
        // console.error('Request failed with response data:', error.response.data);
        console.log('Response status:', error.response.status);
        // console.log('Response headers:', error.response.headers);
    } else if (error.request) {
        console.log('Request made but no response received. Check your network connection or server:', error.request);
    } else {
        console.log('Error setting up the request:', error.message);
    }
    throw error;
};

// GET call
const get = async (url, params = {}) => {
    const token = getAuthToken();
    try {
        const response = await axiosInstance.get(url
            // {
            //     params,
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //     },
            // }
        );
        return response.data;
    } catch (error) {
        handleRequestError(error);
    }
};

// POST call
const post = async (url, data = {}) => {
    const token = getAuthToken();
    try {
        const response = await axiosInstance.post(url, data
            //  {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //     },
            // }
        
        );
        return response.data;
    } catch (error) {
        handleRequestError(error);
    }
};

export { get, post };
